import {
  CarrierLogoWrapperStyled,
  CarrierLogoStyled,
} from './CarrierLogoStyled';

export interface CarrierLogoProps {
  name: string;
  url: string;
}

export const CarrierLogo = ({ name, url }: CarrierLogoProps) => (
  <CarrierLogoWrapperStyled>
    <CarrierLogoStyled src={url} alt={name} data-testid="carrier-logo" />
  </CarrierLogoWrapperStyled>
);
